import { Component } from '@angular/core';
import { FooterService } from './footer.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  openCompany: boolean = true;
  shopCompany: boolean = true;
  helpCompany: boolean = true;
  connectCompany: boolean = true;
  policyModal: boolean = false;
  info;

  constructor(private footer: FooterService) {}

  showPolicy(policy) {
    this.info = this.footer[policy];
    this.policyModal = true;
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/footer/footer.component.ts